<template>
  <footer class="footer">
    <div class="container">
      <nav>
        <ul>
          <li>
            <a></a>
          </li>
          <li>
            <a></a>
          </li>
          <li>
            <a></a>
          </li>
          <li>
            <a></a>
          </li>
        </ul>
      </nav>
      <div class="copyright text-center">
        &copy; {{ new Date().getFullYear() }}
        <a href="https://github.com/antoniofavarinfreire" target="_blank"
          >Antonio Favarin Freire</a
        >
      </div>
    </div>
  </footer>
</template>
<script>
export default {};
</script>
<style></style>
